<template>
    <div>
        <geometry-element
                :selectable="movingElement"
                :movable="isHexagonalModeling ? false : (!isReadOnly && movingElement)"
                :resizable="!isReadOnly && movingElement && isEditElement"
                :deletable="!isReadOnly && movingElement && isEditElement"
                connectable
                :id.sync="elementCoordinate.id"
                :x.sync="elementCoordinate.x"
                :y.sync="elementCoordinate.y"
                :width.sync="elementCoordinate.width"
                :height.sync="elementCoordinate.height"
                :angle.sync="elementCoordinate.angle"
                :customMoveActionExist="isCustomMoveExist"
                v-on:customMoveAction="delayedMove"
                v-on:moveShape="onMoveShape"

                v-on:removeShape="onRemoveShape"
                v-on:dblclick="openPanel"
                v-on:selectShape="selectedActivity"
                v-on:deSelectShape="deSelectedActivity"
                v-on:addedToGroup="onAddedToGroup"
                :label.sync="namePanel"
                :image.sync="setImg"
                :_style="{
                'label-angle': isHexagonalModeling ? 0 : value.elementView.angle,
                'font-weight': 'bold','font-size': '16'
                }"
        >
            <!--v-on:dblclick="$refs['dialog'].open()"-->
            <geometry-rect
                    v-if="movingElement"
                    :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#BB94BF',
          fill: '#BB94BF',
          'fill-opacity': 1,
          r: '1'
        }"
            >
            </geometry-rect>
            <geometry-rect
                    v-else
                    :_style="{
          'fill-r': 1,
          'fill-cx': .1,
          'fill-cy': .1,
          'stroke-width': 1.4,
          'stroke': '#BB94BF',
          fill: '#BB94BF',
          'fill-opacity': .5,
          r: '1'
        }"
            >
            </geometry-rect>

            <sub-elements v-if="!isHexagonalModeling" v-for="(index) in newEditUserImg.length">
                <image-element
                        v-bind:image="newEditUserImg[index-1].picture"
                        :sub-width="'24px'"
                        :sub-height="'24px'"
                        :sub-right="(10*(index-1))+'px'"
                        :sub-bottom="value.elementView.height"
                >
                </image-element>
            </sub-elements>

            <sub-elements>
                <geometry-point
                        :coordinate="[95,5]"
                        :_style="statusCompleteStyle">
                </geometry-point>

                <!--title-->
                <image-element
                        v-if="showValidation"
                        v-bind:image="showValidationImg"
                        :sub-width="'20px'"
                        :sub-height="'20px'"
                        :sub-right="'5px'"
                        :sub-bottom="'5px'"
                >
                </image-element>


                <text-element
                        v-if="!isHexagonalModeling"
                        :sub-width="'100%'"
                        :sub-height="titleH"
                        :sub-top="0"
                        :sub-left="0"
                        :text="value.classReference ? value.classReference : '<< Policy >>'">
                </text-element>
                <storming-sub-controller :type="value._type" :value="value"
                                         :readOnly="isReadOnly"></storming-sub-controller>
            </sub-elements>
        </geometry-element>



        <policy-definition-panel
                v-if="propertyPanel"
                v-model="value"
                :readOnly="!isEditElement"
                :newEditUserImg="newEditUserImg"
                :image="image"
                :validationLists="filteredElementValidationResults"
                @close="closePanel"
                @changedPanelValue="changedPanelValue"
        ></policy-definition-panel>

    </div>
</template>

<script>
    import PolicyDefinitionPanel from "../panels/PolicyDefinitionPanel";
    import Element from './EventStormingModelElement'

    var changeCase = require('change-case');
    var pluralize = require('pluralize');

    var Mustache = require('mustache')

    export default {
        mixins: [Element],
        name: 'policy-definition',
        components:{PolicyDefinitionPanel},
        computed: {
            namePascalCase() {
                var me = this
                return me.name.charAt(0).toUpperCase() + me.name.slice(1)
            },
            defaultStyle() {
                return {}
            },
            className() {
                return 'org.uengine.modeling.model.Policy'
            },
            createNew(elementId, x, y, width, height, description, label) {

                return {
                    _type: 'org.uengine.modeling.model.Policy',
                    name: '',
                    oldName: '',
                    namePascalCase: '',
                    nameCamelCase: '',
                    namePlural: '',
                    description: null,
                    author: null,
                    boundedContext: {},
                    elementView: {
                        '_type': 'org.uengine.modeling.model.Policy',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({})
                    },
                    hexagonalView: {
                        '_type': 'org.uengine.modeling.model.PolicyHexagonal',
                        'id': elementId,
                        'x': x,
                        'y': y,
                        'width': width,
                        'height': height,
                        'style': JSON.stringify({}),
                        'angle': 0,
                    },
                    relationEventInfo: [],
                    relationAggregateInfo: [],
                    relationViewInfo: []
                }
            },

        },
        data: function () {
            return {
                itemH: 20,
                titleH: (this.value.classReference ? 60 : 30),
                reference: this.value.classReference != null,
                referenceClassName: this.value.classReference,
                // isValueChanged: false,
            };
        },
        created: function () {
        },
        watch: {

        },
        mounted: function () {
        },
        methods: {
            // close(){
            //     this.closePanel()
            // },
            validate(panelValue, executeRelateToValidate) {
                var me = this
                var executeValidate = executeRelateToValidate == false ? false :true
                var validateValue = me.propertyPanel && panelValue ? panelValue : me.value

                // Common
                this.$super(Element).validate()

                // execute Relate Validate
                if(executeValidate) {

                }

                // Element
                if(validateValue.name){
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME))
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( isExistValidationResult ){
                        me.elementValidationResults.splice(validationResultIndex,1)
                    }
                }else{
                    var validationResultIndex = me.elementValidationResults.findIndex(x=> (x.code == me.ESE_NOT_NAME) )
                    var isExistValidationResult = validationResultIndex == -1 ? false: true
                    if( !isExistValidationResult ){
                        me.elementValidationResults.push(me.validationFromCode(me.ESE_NOT_NAME))
                    }
                }
            }
        }
    }
</script>



<style scoped lang="scss" rel="stylesheet/scss">
    .panel-title {
        font-size: 25px;
        color: #757575;
    }
</style>
